import Vue from 'vue';
import { PlatformNotificationService } from '@/modules/notifications/services/PlatformNotificationService';

export const PlatformNotifications = {
  install(vue: typeof Vue) {
    vue.prototype.$platformNotifications = new PlatformNotificationService();
  },
};
